module.exports = __webpack_public_path__ + "img/sub20.bc9b70f9.jpg";